import "./polyfill"
import "./index.css";
import React from "react";
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import {registerServiceWorker, unregister} from "./registerServiceWorker";
import history from "./utils/history";
import {configurationFile} from "./utils/config";

const {domain, clientId, audience} = configurationFile[process.env["REACT_APP_ENV"]];

const onRedirectCallback = appState => {   // routes user to right place after login
  history.push((appState && appState.targetUrl) || window.location.pathname)
}

ReactDOM.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={window.location.origin}
    audience={audience}
    onRedirectCallback={onRedirectCallback}
  >
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  </Auth0Provider>,
  document.getElementById("root")
);

unregister();
